export const _setStudentId = (state, action) => {
  state.studentId = action.payload;
};

export const _setStudentName = (state, action) => {
  state.studentName = action.payload;
};

export const _setSubject = (state, action) => {
  state.subject = action.payload;
};

export const _setSubjectName = (state, action) => {
  state.subjectName = action.payload;
};

export const _setDate = (state, action) => {
  state.date = action.payload;
};

export const _setOverrideLimits= (state, action) => {
  state.overrideLimits = action.payload;
};
